export interface AddressCategoryOption {
  label: string;
  value: string;
}

export const addressCategoryOptions: AddressCategoryOption[] = [
  { label: "Headquarter", value: "hq" },
  { label: "Subsidiary", value: "subsidiary" },
  { label: "Branch Office", value: "branch" },
];

export const isHeadquarterCategory = (category?: string): boolean => {
  if (!category) return false;
  const lower = category.toLowerCase().trim();
  return lower === "hq" || lower === "headquarter";
};

export const getAvailableAddressCategoryOptions = (
  addressItems: Array<{ addressCategory?: string }>,
  editingIndex: number | null = null,
  allOptions: AddressCategoryOption[] = addressCategoryOptions,
): AddressCategoryOption[] => {
  const isHqUsedByOther = addressItems.some(
    (item, index) => index !== editingIndex && isHeadquarterCategory(item.addressCategory),
  );

  if (isHqUsedByOther) {
    return allOptions.filter((option) => !isHeadquarterCategory(option.value));
  }
  return allOptions;
};

export const getAvailableBranchOptions = <T extends { branchName: string }>(
  branchItems: T[],
  addressItems: Array<{ branch?: string }>,
  editingIndex: number | null = null,
): Array<{ label: string; value: string }> => {
  const usedBranchesByOther = new Set(
    addressItems
      .filter((_, index) => index !== editingIndex)
      .map((item) => item.branch)
      .filter(Boolean),
  );

  return branchItems
    .filter((b) => !usedBranchesByOther.has(b.branchName))
    .map((b) => ({ label: b.branchName, value: b.branchName }));
};

export const getOptionLabel = (
  options: Array<{ label: string; value: string }>,
  value: string,
): string => options.find((option) => option.value === value)?.label ?? value;

